import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.visible ? _c('my-modal', {
    attrs: {
      "data-sign": "maintenance_compliance_officer_add_edit_modal",
      "width": 1000,
      "title": _vm.parentData.title
    },
    on: {
      "cancel": _vm.handleClose,
      "ok": _vm.handleOk
    },
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c('div', {
    staticClass: "compliance"
  }, [_c('div', {
    staticClass: "compliance-theader"
  }, [_c('div', {
    staticClass: "compliance-tr"
  }, [_c('div', {
    staticClass: "compliance-td checkbox"
  }, [_c('a-checkbox', {
    attrs: {
      "indeterminate": _vm.indeterminate,
      "checked": _vm.checkAll
    },
    on: {
      "change": _vm.handleCheckAllChange
    }
  })], 1), _c('div', {
    staticClass: "compliance-td item1"
  }, [_vm._v(_vm._s(_vm.t('商品编码')))]), _c('div', {
    staticClass: "compliance-td item2"
  }, [_vm._v(_vm._s(_vm.t('进口国')))]), _c('div', {
    staticClass: "compliance-td item3"
  }, [_vm._v(_vm._s(_vm.t('合规负责人')))])])]), _c('a-skeleton', {
    attrs: {
      "active": "",
      "loading": _vm.loadingStatus
    }
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "rules": _vm.formDataRule,
      "data-sign": "maintenance_compliance_officer_add_edit_form",
      "model": _vm.formData
    }
  }, [_c('div', {
    staticClass: "compliance-tbody"
  }, [_c('a-checkbox-group', {
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: _vm.checkedList,
      callback: function ($$v) {
        _vm.checkedList = $$v;
      },
      expression: "checkedList"
    }
  }, _vm._l(_vm.formData.data, function (item, index) {
    return _c('sub-select', {
      key: index,
      attrs: {
        "data": item,
        "index": index,
        "complianceOfficerList": _vm.complianceOfficerList,
        "formDataRule": _vm.formDataRule
      }
    });
  }), 1)], 1)])], 1)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a-button', {
    attrs: {
      "data-sign": "maintenance_compliance_officer_add_edit_cancel",
      "data-permission": "maintenance_compliance_officer_add_edit_cancel",
      "id": "maintenance_compliance_officer_add_edit_cancel",
      "fbu-analyse-name": $t("\u53D6\u6D88")
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v(_vm._s(_vm.t('取消')))]), _c('a-button', {
    attrs: {
      "type": "primary",
      "data-sign": "maintenance_compliance_officer_add_edit_submit",
      "data-permission": "maintenance_compliance_officer_add_edit_submit",
      "id": "maintenance_compliance_officer_add_edit_submit",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleOk
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)]) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };